/**
 * Converts distance from degrees to feet
 * @param distance Distance in degrees
 * @returns Formatted distance string in feet
 */
export const formatDistance = (distance: number): string => {
  const distanceInMeters = distance * 111000;

  const distanceInFeet = distanceInMeters * 3.28084;

  if (distanceInFeet < 0.33) {
    return '< 1 ft';
  } else if (distanceInFeet < 5280) {
    return `${Math.round(distanceInFeet)} ft`;
  } else {
    const distanceInMiles = distanceInFeet / 5280;
    return `${distanceInMiles.toFixed(2)} mi`;
  }
};

/**
 * Calculates distance between two geographic points in degrees
 * @param lat1 Latitude of first point
 * @param lon1 Longitude of first point
 * @param lat2 Latitude of second point
 * @param lon2 Longitude of second point
 * @returns Distance in degrees
 */
export const calculateDistance = (
  lat1: number,
  lon1: number,
  lat2: number,
  lon2: number
): number => {
  const R = 6371;
  const dLat = ((lat2 - lat1) * Math.PI) / 180;
  const dLon = ((lon2 - lon1) * Math.PI) / 180;
  const a =
    Math.sin(dLat / 2) * Math.sin(dLat / 2) +
    Math.cos((lat1 * Math.PI) / 180) *
      Math.cos((lat2 * Math.PI) / 180) *
      Math.sin(dLon / 2) *
      Math.sin(dLon / 2);
  const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
  const distanceInKm = R * c;

  return distanceInKm / 111;
};
